import React from "react";

export default function NumberDatatype({ value }) {
  return <span style={{color: '#a6a2ee', fontFamily: 'Roboto Mono'}}>{value}</span>;
}